module.exports = __webpack_public_path__ + "97964360.svg";